'use strict';

var CookieStateSource = require('./cookie');
var registerStateSource = require('../core/registerStateSource');

module.exports = function (marty) {
  registerStateSource(marty, 'CookieStateSource', 'cookie', CookieStateSource);
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/marty-lib/modules/cookie-state-source/index.js
 ** module id = 553
 ** module chunks = 0
 **/